import { render, staticRenderFns } from "./DetailRecord.vue?vue&type=template&id=4b6b1794&"
import script from "./DetailRecord.vue?vue&type=script&lang=js&"
export * from "./DetailRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports